export enum SortingDirection {
    ascending = 'ASC',
    descending = 'DESC',
}

export enum SortingValue {
    byRoadName = 'ROAD_NAME',
    byCreationDate = 'CREATION_DATE',
}
